import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { ErrorBoundary } from './components/ErrorBoundary'
import './styles.css'

/**
 * Render IMMEDIATELY. Nothing async may gate the first paint.
 *
 * The previous version awaited hydrateToken() — a Capacitor Preferences call —
 * and rendered in .finally(). If the native bridge isn't ready when that call
 * is made, the promise never settles, .finally() never runs, and the user gets
 * a permanently black screen with no error anywhere. Session recovery now
 * happens inside App's boot effect, where it is bounded by a timeout and can
 * only ever delay the sign-in screen, never replace it with nothing.
 */
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)

// Stand the boot watchdog in index.html down — we painted.
declare global {
  interface Window { __liftPainted?: () => void }
}
window.__liftPainted?.()
